import { render, staticRenderFns } from "./salary.vue?vue&type=template&id=3ef1b2c4&scoped=true&"
import script from "./salary.vue?vue&type=script&lang=js&"
export * from "./salary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef1b2c4",
  null
  
)

export default component.exports